/// <amd-module name="SuiteCommerce.GiftCertificate.GiftCertificateMessage.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.GiftCertificateMessage.Model", ["require", "exports", "Backbone"], function (require, exports, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.GiftCertificateMessageModel = void 0;
    var GiftCertificateMessageModel = /** @class */ (function (_super) {
        __extends(GiftCertificateMessageModel, _super);
        function GiftCertificateMessageModel(options) {
            return _super.call(this, options) || this;
        }
        Object.defineProperty(GiftCertificateMessageModel.prototype, "message", {
            get: function () {
                return this.get('message');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateMessageModel.prototype, "type", {
            get: function () {
                return this.get('type');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(GiftCertificateMessageModel.prototype, "closable", {
            get: function () {
                return this.get('closable');
            },
            enumerable: false,
            configurable: true
        });
        return GiftCertificateMessageModel;
    }(Backbone_1.Model));
    exports.GiftCertificateMessageModel = GiftCertificateMessageModel;
});
